import { useState, Fragment } from 'react';
import Tree from '../../../../Components/Tree';
import Globals from '../../../../Globals.json';
import './styles.scss';
import { IListCategories } from '../../../../Pages/Cadastro/cadCategorias';
import Pagination from '../../../data/pagination';
import LayoutNotFilter from '../../../data/LayoutNotFilter';
import { useAppSelector } from '../../../../redux/store';
import { NoData } from '../../../noData';
import CustomLoader from '../../../data/customLoader';
import { useQueryFetchPages } from '../../../../apiQuery/useQueryFetchPages';
import { DataError } from '../../../DataError';
import { Btn } from '../../../data/Btn';
import { ModalAjusteImpressoras } from '../../../ModalAjusteImpressoras';
import { ModalAjustePerfilFiscal } from '../../../ModalAjustePerfilFiscal';

export default function ListaCategorias({
  OnAddNewCli,
  title,
  onEditItem,
  OnAddNewCategorie,
}: IListCategories) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const [page, setPage] = useState<number>(0);
  const [showPrinters, setShowPrinters] = useState<boolean>(false);
  const [showTaxProfile, setShowTaxProfile] = useState<boolean>(false);

  const { data, isLoading, isError } = useQueryFetchPages<any>(
    ['category'],
    `${Globals.api.treeCategories}`,
    {
      page: page + 1,
      queryParams: {
        store_id: storeMe?.storeActive?.id,
      },
    }
  );
  const treeList = data?.data || [];
  const meta = data?.meta;

  const handleAdd = () => {
    OnAddNewCli(true);
  };

  return (
    <LayoutNotFilter
      title={title}
      onClickAdd={handleAdd}
      actions={
        <>
          <Btn
            text="Ajuste de Impressoras"
            type="button"
            variante="secondary"
            onClick={() => setShowPrinters(true)}
          />
          <Btn
            text="Ajuste Perfil Fiscal"
            type="button"
            variante="secondary"
            onClick={() => setShowTaxProfile(true)}
          />
        </>
      }
    >
      <ModalAjusteImpressoras
        show={showPrinters}
        onHide={() => setShowPrinters(false)}
      />
      <ModalAjustePerfilFiscal
        show={showTaxProfile}
        onHide={() => setShowTaxProfile(false)}
      />
      {isLoading ? (
        <CustomLoader />
      ) : treeList.length > 0 ? (
        <>
          <div className="mt-4 mx-4 mb-4">
            {treeList.map((tree: any) => (
              <Fragment key={tree.id}>
                <Tree
                  category={tree}
                  onEditItem={onEditItem}
                  OnAddNewCategorie={OnAddNewCategorie}
                  handleFetchTree={() => {}}
                />
              </Fragment>
            ))}
          </div>

          <Pagination
            page={page}
            setPage={setPage}
            itensFrom={meta?.from || 0}
            itensTo={meta?.to || 0}
            lastPage={meta?.last_page || 0}
            totalPages={meta?.total || 0}
          />
        </>
      ) : isError ? (
        <DataError title="Categorias" />
      ) : (
        <NoData />
      )}
    </LayoutNotFilter>
  );
}
